// Third-party
import React from 'react';
import { withFormik, FormikProps, Form } from 'formik';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormCheckbox, FormInput } from '../../components/forms';
import ExternalLink from '../../components/ExternalLink';

// Utils
import { formatMessage, FormattedMessage } from '../../../utils/i18n';

type FormProps = {
  rememberMe: boolean;
  code: string;
};

type ParentProps = {
  helpUrl: string;
  loading: boolean;
  onSubmit: (rememberMe: boolean, otp?: string, backup?: string) => Promise<void>;
};

type Props = ParentProps & FormikProps<FormProps>;

const canSubmit = (props: Props) => {
  const { values, initialValues, isSubmitting, errors } = props;

  const hasErrors = Object.keys(errors).length > 0;
  const isDirty = values !== initialValues;

  return !hasErrors && isDirty && !isSubmitting;
};

const Auth2FABackup = (props: Props) => (
  <div className="login">
    <h1 className="two-factor-header">
      <FormattedMessage id="TwoFactorAuthentication.Headers.UseYourBackupCode" />
    </h1>

    <p className="sub-title">
      <FormattedMessage id="TwoFactorAuthentication.Texts.EnterYourBackupCode" />
    </p>

    <Form>
      <FormInput name="code" type="text" label={formatMessage('TwoFactorAuthentication.Headers.BackupCode')} autoComplete="off" />
      <FormCheckbox name="rememberMe" label={formatMessage('TwoFactorAuthentication.Texts.RememberMe')} />

      <Button variant="primary" loading={props.loading} type="submit" disabled={!canSubmit(props)}>
        <FormattedMessage id="TwoFactorAuthentication.Buttons.Next" />
      </Button>
    </Form>
    <div className="text-center mt-4">
      <Link className="d-block" to="/auth/2fa">
        <FormattedMessage id="TwoFactorAuthentication.Buttons.UseAuthApp" />
      </Link>
      <ExternalLink to={props.helpUrl} className="d-block mt-4">
        <FormattedMessage id="TwoFactorAuthentication.Buttons.HowToGetConfirmationCode" />
      </ExternalLink>
    </div>
  </div>
);

const TwoFactorAuth = Yup.object().shape({
  rememberMe: Yup.boolean().required(),
  code: Yup.string().required(),
});

const formikWrapper = withFormik<Props, FormProps>({
  validationSchema: TwoFactorAuth,
  mapPropsToValues: () => ({ rememberMe: false, code: '' }),
  handleSubmit: ({ rememberMe, code }, { props, setSubmitting }) => {
    props.onSubmit(rememberMe, undefined, code).finally(() => setSubmitting(false));
  },
});

export default formikWrapper(Auth2FABackup) as any;
